import React, {useContext} from 'react';
import {Backdrop, CircularProgress, createStyles, Theme} from "@material-ui/core";
import makeStyles from '@material-ui/core/styles/makeStyles';
import "./index.scss"
import {ProcessingContext} from "../../../contexts/ProcessingContext";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        backdrop: {
            zIndex: theme.zIndex.drawer + 1
        }
    })
);

export const ProcessingDialog = () => {
    const {isProcessingOpen, processingText, processingTitle} = useContext(ProcessingContext);
    const classes = useStyles();

    return (
        <div>
            <Backdrop open={isProcessingOpen} className={classes.backdrop}>
                <div className={"processing-dialog"}>

                    <div className="processing-dialog__title">
                        <span>{processingTitle}</span>
                    </div>

                    <div className="processing-dialog__text">
                        <span>{processingText}</span>
                    </div>

                    <div className="processing-dialog__circ">
                        <CircularProgress color="inherit"/>
                    </div>

                </div>
            </Backdrop>
        </div>
    )
};